import { GlobalSettingDto, EshopGlobalSettingService } from '@/api';

export default {
  getGlobalSetting: async (): Promise<GlobalSettingDto[]> => {
    const response = await EshopGlobalSettingService.eshopGlobalSettingControllerGetAll();
    return response.data;
  },
};
